import {
  CreateAgreementPayloadDto
} from '@features/agreement/application/use_cases/create-agreement/dto/create-agreement.payload.dto';
import {
  CreateAgreementResponseDto
} from '@features/agreement/application/use_cases/create-agreement/dto/create-agreement.response.dto';
import {
  CreateAgreementHttpPayloadDto
} from '@features/agreement/infrastructure/http/create-agreement/create-agreement.http.payload.dto';
import {
  CreateAgreementHttpResponseDto
} from '@features/agreement/infrastructure/http/create-agreement/create-agreement.http.response.dto';

export class CreateAgreementHttpMapper {

  static toResponse(data: CreateAgreementHttpResponseDto): CreateAgreementResponseDto {
    return {};
  }

  static toInfra(data: CreateAgreementPayloadDto): CreateAgreementHttpPayloadDto {
    return {
      ...data
    };
  }

}
